//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { IntegerResultDTO } from 'src/app/core/interfaces/general/integer-result';
import { LicenceSystemDTO } from 'src/app/core/models/system/licence/licence-system.dto';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class LicencesSystemService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
  
  public getById(id: number): Observable<LicenceSystemDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.LicencesSystem +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getIdByLicenceName(licenceName: string): Observable<IntegerResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(licenceName, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const licenceNameEncSS=encResult.result;
                            
                            return this.httpClientService.getByDescription(environment.eSimApi +
                                                                           eSimApiPaths.LicencesSystem + "/" +
                                                                           eSimApiPaths.GetIdByLicenceName +
                                                                           "?licenceNameEncSS=", licenceNameEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getLicencesSystem(): Observable<LicenceSystemDTO[]> {
    try {
      return this.httpClientService.get<LicenceSystemDTO[]>(environment.eSimApi +
                                                            eSimApiPaths.LicencesSystem + "/" +
                                                            eSimApiPaths.LicencesSystemGetLicencesSystem);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(licenceSystem: LicenceSystemDTO): Observable<LicenceSystemDTO> {
    try {
      //JSON.stringify(licenceSystem)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(licenceSystem), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.LicencesSystem +
                                                               "?objectEncSS=" + objectEncSS, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
    
  public put(licenceSystem: LicenceSystemDTO): Observable<LicenceSystemDTO> {
    try {
      //JSON.stringify(licenceSystem)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(licenceSystem), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.LicencesSystem +
                                                              "?id=" + licenceSystem.id +
                                                              "&objectEncSS=" + objectEncSS, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public save(licenceSystem: LicenceSystemDTO): Observable<LicenceSystemDTO> {
    try {
      //JSON.stringify(licenceSystem);

      if (licenceSystem.id && <number>licenceSystem.id>0)
        return this.put(licenceSystem);
      
      return this.post(licenceSystem);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
